<template>
  <div>
    <div class="d-flex justify-space-between pl-5 pr-5">
      <h2 color="#6A158E" class="table-heading">
        Sessions
      </h2>

      <template v-if="is_free_assessment === '0' && this.sessionAdd == '1' && students.length != '0'">
        <v-btn color="#6A158E" dark @click="openDialoge"> + Add Session</v-btn>
      </template>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <!-- <template v-slot:activator="{ on, attrs2 }" v-if="is_free_assessment === '0'"> -->
        <!-- <template v-slot:activator="{ on, attrs2 }" v-if="this.sessionAdd == '1'">
        
           <v-btn color="#6A158E" dark v-bind="attrs2" v-on="on">+ Add Session</v-btn>
        </template> -->
        <!-- </template> -->

        <v-card>
          <v-card-title>
            <span class="headline">Add Session</span>
          </v-card-title>

          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card-text>
              <v-container>
                <template>
                  <v-row>
                    <v-col>
                      <label class="custom-label">Select Virtual Class Room</label>
                      <v-select @change="setVcTool" :rules="[rules.required]" :items="selectVirtual" item-value="id"
                        item-text="tag" label="Select Virtual Class Room" v-model="data.VcTool" solo></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="custom-label">Date</label>
                      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                        :return-value.sync="data.end_date" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :rules="[rules.required]" :value="computedDate" label="Choose Dates"
                            :error-messages="errors.end_date" prepend-icon readonly v-bind="attrs" v-on="on" solo>
                          </v-text-field>
                        </template>
                        <v-date-picker :first-day-of-week="1" v-model="data.end_date" no-title scrollable>
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                          <v-btn text color="primary" @click="$refs.menu2.save(data.end_date)">OK</v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <label class="custom-label">Select Session Type</label>
                      <v-select :rules="[rules.required]" :items="session_types" label="Session Type"
                        v-model="data.session_type" solo></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <label class="custom-label">Start Time</label>
                      <v-menu ref="menu" v-model="startTimeMenu" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="data.start_time" transition="scale-transition" offset-y max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :rules="[rules.required]" :error-messages="errors.start_time"
                            v-model="data.start_time" label="Start Time" prepend-icon v-bind="attrs" v-on="on" solo>
                          </v-text-field>
                        </template>
                        <v-time-picker v-if="startTimeMenu" v-model="data.start_time" full-width
                          @click:minute="$refs.menu.save(data.start_time)" :ampm-in-title="ampmInTitle"
                          :format="format"></v-time-picker>
                      </v-menu>
                    </v-col>

                    <v-col>
                      <label class="custom-label">End Time</label>
                      <v-menu ref="menu3" v-model="endTimeMenu" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="data.end_time" transition="scale-transition" offset-y max-width="290px"
                        min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field :rules="[rules.required]" :error-messages="errors.end_time"
                            v-model="data.end_time" label="End Time" prepend-icon v-bind="attrs" v-on="on" solo>
                          </v-text-field>
                        </template>
                        <v-time-picker v-if="endTimeMenu" v-model="data.end_time" full-width
                          @click:minute="$refs.menu3.save(data.end_time)" :ampm-in-title="ampmInTitle" :format="format">
                        </v-time-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-row v-for="student in state_students" :key="student.std_id">
                        <v-col cols="6">
                          {{ student.std_fname + " " + student.std_lname }}
                        </v-col>
                        <v-col cols="6">
                          <v-combobox v-model="data.works_array[student.std_id]" :items="works"
                            :search-input.sync="search" hide-selected label="Select Work" multiple small-chips
                            item-value="item.work_id" item-text="work_name">
                          </v-combobox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-alert outlined text type="warning" v-if="has_teacher_date_error">Tutor({{ tutor.full_name }})
                          is not available at this
                          day. Please Choose different date.</v-alert>
                      </v-row>
                      <template v-if="na_students.length > 0">
                        <v-row>
                          <v-alert outlined text type="warning">Below is the list of students who are not available
                            on: {{ data.selected_day }}</v-alert>
                        </v-row>
                        <v-row>
                          <v-layout child-flex>
                            <v-simple-table>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">Name</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="na_student in na_students" :key="na_student.std_id">
                                    <td>
                                      {{ na_student.std_fname }}
                                      {{ na_student.std_lname }}
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-layout>
                        </v-row>
                      </template>
                    </v-col>
                  </v-row>
                </template>
              </v-container>
            </v-card-text>
          </v-form>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addSession">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-data-table :page.sync="page" @page-count="pageCount = $event" :items="sessions" :headers="headers"
      hide-default-header hide-default-footer>
      <template v-slot:header="{ props: {} }">
        <thead class="v-data-table-header">
          <tr>
            <th role="columnheader" scope="col" class="text-start">
              <span>Session No.</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Date</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Start Time</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>End Time</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Session Type</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Room Type</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Link clipboard</span>
            </th>
            <th role="columnheader" scope="col" class="text-start">
              <span>Student Links</span>
            </th>
            <th role="columnheader" scope="col" colspan="5">
              <span>Action</span>
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:[`item.class_link`]="{ item }">
        <span class="table-tutor-name">      
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              
              <span v-for="session in sessions" :key="session" style="margin-right:2px;">
              <v-btn v-on="on" v-bind="attrs" depressed @click="copyText(session.session_link.class_link)"  color="primary">
                S
              </v-btn>
          </span>
            </template>
            <span>Student Link</span>

          </v-tooltip> -->

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="item.session_status  == 1" v-on="on" v-bind="attrs" depressed @click="copyText(item.class_link)" color="primary">
                  T 
              </v-btn>
            </template>
            <span>Tutor Link</span>
          </v-tooltip>
          
        </span>
      </template>

      <template v-slot:[`item.group_sessions`]="{ item }">
        <span class="table-tutor-name" v-if="item.session_status == '1'">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <span v-for="student in students" :key="student">
                <v-btn class="mx-1" v-if="link.student_id == student.std_id" v-for="link in item.session_links" :key="link" v-on="on" v-bind="attrs" depressed @click="copyText(link.class_link)" color="primary">
                  {{ ( link.student_id == student.std_id) ?  student.std_fname.charAt(0)  : '' }}
                </v-btn>
              </span>
            </template>
            <span>Student Link</span>
          </v-tooltip>
        </span>
      </template>

      <template v-slot:[`item.session_date`]="{ item }">
        <span class="table-tutor-name">
          {{ moment(item.session_date, 'YYYY-MM-DD').format("DD-MM-YYYY") }}
        </span>
      </template>
      <template v-slot:[`item.tool`]="{ item }">
        <span class="table-tutor-name">
          {{  (item.session_type == 'online') ? (item.tool) ? (item.tool == 1 ) ? 'VC Tool' : 'Wiz IQ' : 'Not Found' : '' }}
        </span>
      </template>
      <template v-slot:[`item.session_type`]="{ item }">
        <span class="table-tutor-name">
          {{  (item.session_type == 'online') ? 'Online' : 'In Center' }}
        </span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-row>
          <!-- {{ item }} -->
          <span v-if="item.session_status == '1'" class="table-tutor-name">
            <v-btn color="red darken-1 white--text ml-1" @click="cancelSession(item)">Cancel</v-btn>
          </span>
          <span v-if="item.session_status == '0'">
            <!-- <v-btn color="blue darken-1 white--text ml-1" @click="rescheduleSession(item)">Reschedule</v-btn> -->
            <v-btn color="red darken-1 white--text ml-1">Not Available</v-btn>
          </span>
          <span v-if="is_free_assessment === '1' && item.session_type === 'online' && item.session_status == '1'">
            <v-btn color="green darken-1 white--text ml-1" @click="resentOnlineEmail(item)">Re-submit Email</v-btn>
          </span>
          <span v-if="is_free_assessment === '1' && item.session_type === 'in-center'">
            <v-btn color="green darken-1 white--text ml-1" @click="resentInCenterEmail(item)">Re-submit Email</v-btn>
          </span>
        </v-row>
      </template>
    </v-data-table>

    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Enquiries
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
            students.length
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="pageCount"></v-pagination>
    </div>
    <v-overlay style="z-index: 99999" :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
const __VALIDATIONS = {
  required: "This Field is required",
  greater_then: "Must be greater than 6 characters",
  valid_email: "E-mail must be valid",
};
import moment from "moment";
import { bus } from "../../main";
import Swal from 'sweetalert2'
window.Swal = Swal;

export default {
  name: "SessionTable",
  data() {
    return {
      rules: {
        required: (value) => !!value || __VALIDATIONS.required,
        min: (value) => value >= 6 || __VALIDATIONS.greater_then,
        email: (value) => /.+@.+\..+/.test(value) || __VALIDATIONS.valid_email,
      },
      isVcTool: false,
      sessionAdd: null,
      session_types: ["incentre", "online"],
      lazy: false,
      valid: true,
      has_student_date_error: false,
      has_teacher_date_error: false,
      overlay: false,
      ampmInTitle: true,
      state_students: [],
      na_students: [],
      selected_day: "",
      format: "ampm",
      search: null,
      errors: {},
      dialog: false,
      moment: moment,
      page: 1,
      data: {
        VcTool: 1,
        works_array: [],
        end_date: null,
      },
      menu: false,
      menu2: false,
      menu3: false,
      startTimeMenu: null,
      endTimeMenu: null,
      pageCount: 3,
      itemsPerPage: 10,
      selectVirtual: [
        { id: 1, tag: "VC Tool" }
      ],
      headers: [
        {
          text: "Session No.",
          value: "group_session_id",
          sortable: true,
        },
        {
          text: "Date",
          value: "session_date",
          sortable: false,
        },
        {
          text: "Start Time",
          value: "session_start_time",
          sortable: true,
        },
        {
          text: "End Time",
          value: "session_end_time",
          sortable: false,
        },
        {
          text: "Session Type",
          value: "session_type",
          sortable: false,
        },
        {
          text: "Room Type",
          value: "tool",
          sortable: false,
        },
        {
          text: "Tutor Link",
          value: "class_link",
          sortable: false,
        },
        {
          text: "Student Link",
          value: "group_sessions",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.state_students = this.students;
    if (this.students.length > 0) {
      this.sessionAdd = "1";
    }
    bus.$on("addSessionStudent", (data) => {
      console.log("sessionAdd", data);
      this.sessionAdd = "1";
      console.log("this.sessionAdd", this.sessionAdd);
    });
  },
  computed: {
    computedDate() {
      if (this.data.end_date) {
        return moment(this.data.end_date).format("DD-MM-YYYY");
      }
    },
  },
  watch: {
    "data.end_date": function (val, oldVal) {
      const date = moment(val); // Thursday Feb 2015
      const dow = date.format("ddd").toLowerCase();
      this.data.selected_day = date.format("dddd");
      this.na_students = [];
      this.has_student_date_error = this.has_teacher_date_error = false;
      this.state_students = this.students.filter((stud) => {
        if (stud.week_hours[dow] !== undefined && stud.week_hours[dow] > 0) {
          return stud;
        }
        // else {
        //     this.has_student_date_error = true;
        //     this.na_students = [...this.na_students, stud];
        // }
      });
      if (
        this.tutor.week_hours[dow] === undefined ||
        this.tutor.week_hours[dow] == 0
      ) {
        this.has_teacher_date_error = true;
      }
    },
  },
  methods: {
    async copyText(text){
       try {
        await navigator.clipboard.writeText(text);
        alert('Copied');
      } catch($e) {
        // Secure Origin Require
        alert('Cannot Copy');
      }
    },
    openDialoge() {
      this.dialog = true;
    },
    setVcTool() {
      this.isVcTool = true;
    },
    resentInCenterEmail(item) {
      // console.table(item);
      this.overlay = true;
      axios
        .get("resend-incenter-email/" + item.group_id)
        .then((response) => {

          this.overlay = false;
          swal("Email Send Successfully");
        })
        .catch((error) => {
          this.overlay = false;
          swal(error.response.data.message);
        });
    },
    resentOnlineEmail(item) {
      // console.table(item);
      this.overlay = true;
      axios
        .get("resend-online-email/" + item.group_id)
        .then((response) => {
          this.overlay = false;
          swal("Email Send Successfully");
        })
        .catch((error) => {
          this.overlay = false;
          swal(error.response.data.message);
        });
    },
    rescheduleSession(item) {
      console.log(item);
      this.dialog = true;
      this.data.end_date = item.session_date;
      this.data.start_time = item.session_start_time;
      this.data.end_time = item.session_end_time;
      this.data.session_id = item.group_session_id;
    },
    cancelSession(item) {
      // this.overlay = true;
      Swal.fire({
        title: 'Do you want to save the changes?',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Save',
        denyButtonText: `Don't save`,
      }).then((result) => {
        if (result.isConfirmed) {
        axios
          .get("cancel/session/" + item.group_session_id)
          .then((response) => {
            this.overlay = false;
            Swal.fire('Class Canceled Successfully!', '', 'success')
            this.$emit("childToParent", this.childMessage);
            // this.$nextTick(
            //   this.sessions = this.sessions
            // )
            this.$router.push('/panel/classes/groups');
          })
          .catch((error) => {
            this.overlay = false;
            swal(error.response.data.message);
          });
          
        } else if (result.isDenied) {
          Swal.fire('Class Not Canceled', '', 'info')
        }
      })
    },
    workSelect(student, item) {
      var obj = {
        student_id: student,
        work_id: item[0].work_id,
      };
      this.data.works.push(obj);
    },
    addSession() {
      let isValidate = this.$refs.form.validate();
      if (isValidate) {
        this.overlay = true;
        if (typeof this.data.start_time === "undefined") {
          alert("Please select all fields");
          this.overlay = false;
          return false;
        }
        if (typeof this.data.end_time === "undefined") {
          alert("Please select all fields");
          this.overlay = false;
          return false;
        }
        if (this.data.end_date === null) {
          alert("Please select all fields");
          this.overlay = false;
          return false;
        }
        if (
          typeof this.data.session_type == "undefined" ||
          this.data.session_type === null
        ) {
          alert("Please select all fields");
          this.overlay = false;
          return false;
        }
        if (this.has_student_date_error || this.has_teacher_date_error) {
          alert("Please Select different date to create session");
          this.overlay = false;
          return false;
        }
        
        axios
          .post(apiRoutes.sessions.addToGroup + this.groupid, this.data)
          .then((response) => { 
            this.dialog = false;
            this.overlay = false;
            this.sessions = [] ;
            this.$nextTick(
              this.sessions = this.sessions
            )
            this.$emit("childToParent", this.childMessage);
          })
          .catch((error) => {
            this.overlay = false;
            console.log(error.response);
            swal(error.response.data.message);
          });
      }
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
  },
  props: [
    "sessions",
    "students",
    "works",
    "groupid",
    "tutor",
    "is_free_assessment",
  ],

  created() { },
};
</script>

<style lang="scss">
.table-heading {
  font: 300 22px/26px;
  font-family: "Gotham Narrow";
  color: #6a158e;
}

.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.v-data-table-header tr:last-of-type th span {
  font: 300 14px/13px Gotham;
  color: #172b4d;
}

.table-tutor {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-attendance {
    font: Bold 14px/13px Gotham;
    color: #129b11;

    &.absent {
      color: #e41b1bf7;
    }
  }
}

.v-btn.v-size--default {
  font-size: 12px;
  text-transform: none;
}
</style>
